import { render, staticRenderFns } from "./App.vue?vue&type=template&id=01f483e2&scoped=true"
import script from "./App.js?vue&type=script&lang=js&external"
export * from "./App.js?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=01f483e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f483e2",
  null
  
)

export default component.exports